(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('impegno', {
            parent: 'entity',
            url: '/impegno?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.impegno.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/impegno/impegnos.html',
                    controller: 'ImpegnoController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('impegno');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('impegno-detail', {
            parent: 'entity',
            url: '/impegno/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.impegno.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/impegno/impegno-detail.html',
                    controller: 'ImpegnoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('impegno');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Impegno', function($stateParams, Impegno) {
                    return Impegno.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'impegno',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('impegno-detail.edit', {
            parent: 'impegno-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/impegno/impegno-dialog.html',
                    controller: 'ImpegnoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Impegno', function(Impegno) {
                            return Impegno.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('impegno.new', {
            parent: 'impegno',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/impegno/impegno-dialog.html',
                    controller: 'ImpegnoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                esercizio: null,
                                esercizioOrigine: null,
                                codice: null,
                                descrizione: null,
                                utenteCreazione: null,
                                dataCreazione: null,
                                utenteAggiornamento: null,
                                dataAggiornamento: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('impegno', null, { reload: 'impegno' });
                }, function() {
                    $state.go('impegno');
                });
            }]
        })
        .state('impegno.edit', {
            parent: 'impegno',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/impegno/impegno-dialog.html',
                    controller: 'ImpegnoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Impegno', function(Impegno) {
                            return Impegno.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('impegno', null, { reload: 'impegno' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('impegno.delete', {
            parent: 'impegno',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/impegno/impegno-delete-dialog.html',
                    controller: 'ImpegnoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Impegno', function(Impegno) {
                            return Impegno.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('impegno', null, { reload: 'impegno' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
